module.exports = __webpack_public_path__ + "static/media/bow-arrow.41d40dc4.svg";